import { useRef } from "react";
import { useOutsideClicked } from "@/businessLogics/_common/checks";

export default function OutsideClickedWrapper({ children, setState }) {
  const wrapperRef = useRef(null);
  useOutsideClicked(wrapperRef, setState);
  return <div ref={wrapperRef}>{children}</div>;
}
